export const REMIX_PLACEHOLDER_WIDGET_KEY = 'ai-suggestions-remix-placeholder';

/** Block-level, non-editable host that the RemixPlaceholder portal renders into. */
export function createRemixPlaceholderContainer(): HTMLElement {
	const element = document.createElement('div');
	element.contentEditable = 'false';
	element.setAttribute('style', 'display: block; width: 100%; pointer-events: none;');
	return element;
}
